module.exports = __webpack_public_path__ + "img/chevron-icon-right.6d278556.svg";